import ThumbFilePlaceholder from "./ThumbFilePlaceholder";
import { getRevisionFileExtension } from "../lib/utils";
import { IDocument, IRevision } from "../@types/document";
import { useEffect, useState } from "react";
import Loader from "./Loader";


interface IDocumentCardThumbnail {
	revision: IRevision
	doc: IDocument
}

export default function DocumentCardThumbnail({ revision, doc }: IDocumentCardThumbnail) {
	const fileExtension = getRevisionFileExtension(revision.filename)
	const isPdf = revision.contentType === "application/pdf";
	const [width, setWidth] = useState(0);
	const [isLoading, setIsLoading] = useState(isPdf);
	const [imageError, setImageError] = useState(false);

	useEffect(() => {
		const mediaQuery: MediaQueryList = window.matchMedia("(min-width: 1024px)");

		const handleScreenChange = (e: MediaQueryListEvent | MediaQueryList) => {
			if (e.matches) {
				setWidth(80);
			} else {
				setWidth(60);
			}
		};
		mediaQuery.addEventListener("change", handleScreenChange);
		handleScreenChange(mediaQuery);
		return () => {
			mediaQuery.removeEventListener("change", handleScreenChange);
		};
	}, []);

	const handleImageLoad = () => {
		setIsLoading(false);
	};

	const handleImageError = () => {
		setImageError(true);
		setIsLoading(false);
	};

	return (
		<div className="flex flex-shrink-0 items-center justify-center rounded-[8px] h-[90px] lg:h-[110px] w-[60px] lg:w-[80px] border border-transparent transition-border duration-200 group-hover:border-gray-200">
			{isLoading && <Loader />}
			<a
				href={revision.fileUrl}
				target={"_blank"}
				className={isLoading ? "hidden": ""}
				onClick={() => { window.dataLayer.push({ event: 'document_view_pdf', fileName: revision.filename, documentId: doc._id }); }}
			>
				{!isPdf || imageError ?
					<ThumbFilePlaceholder
						fileExtension={fileExtension}
					/>
					:
					<img
						src={revision.thumbUrl}
						onLoad={handleImageLoad}
						onError={handleImageError}
						className="w-full h-full overflow-hidden rounded-[8px]"
						alt="Document thumbnail"
					/>
				}
			</a>
		</div>
	)
}